export default "__VITE_ASSET__bfd10639__"